export default function() {
    const tagItems = document.querySelectorAll('[data-tag]');
    if (typeof tagItems.length == 'undefined') {
        return;
    }
    for (let i = 0, len = tagItems.length; i < len; i++) {
        if (typeof tagItems[i] == 'undefined') {
            continue;
        }
        tagItems[i].addEventListener('click', function(e) {
            // e.preventDefault();
            dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': getAttribute(this, 'tag'),
                'eventAction': getAttribute(this, 'action'),
                'eventLabel': getAttribute(this, 'label'),
                'eventValue': getAttribute(this, 'value'),
            });
        });
    }

    function getAttribute(e, a) {
        if (typeof e == 'undefined' || typeof e.dataset == 'undefined' || typeof e.dataset[a] == 'undefined') {
            return '';
        }
        return e.dataset[a];
    }
};